import React, { useState } from "react";
import { Box, Collapse } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";

interface SidebarMachineCategoryProps {
  categoryName: string;
  machineCount: number;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

const SidebarMachineCategory: React.FC<SidebarMachineCategoryProps> = ({
  categoryName,
  machineCount,
  defaultExpanded = true,
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box>
      {/* Category header row — spec: padding 6px 8px */}
      <Box
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 8px", /* spec: category row padding — match child row height */
          cursor: "pointer",
          transition: "background-color 0.15s ease",
          borderRadius: "6px",
          "&:hover": { backgroundColor: "#F7F5F0" /* spec: input-bg hover */ },
        }}
      >
        {/* Left side: category name */}
        <Box
          sx={{
            fontFamily: dt.font,
            fontSize: "12px",
            fontWeight: 600,
            color: "#0C1117", /* spec: text-primary */
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            minWidth: 0,
          }}
        >
          {categoryName}
        </Box>

        {/* Machine count — spec: JetBrains Mono 10px */}
        <Box
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "10px",
            fontWeight: 500,
            color: "#8C9099", /* spec: text-muted */
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          {machineCount}
        </Box>
      </Box>

      {/* Children (manufacturer rows) */}
      <Collapse in={expanded}>
        {children}
      </Collapse>
    </Box>
  );
};

export default SidebarMachineCategory;
